export default function (coords) {
  return new Promise(function (resolve, reject) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve([position.coords.latitude, position.coords.longitude])
        },
        error => {
          reject(error)
        }
      )
    } else {
      return reject('No geolocation support')
    }
  })
}
